let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("25Mh8")).then(() => parcelRequire('d7W8O'));